import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const LoadingOverlay = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timer;

    const handleStart = () => {
      setLoading(true);
      setProgress(0);

      // Simulate progress
      timer = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return 90;
          return prev + Math.random() * 10;
        });
      }, 200);
    };

    const handleComplete = () => {
      setProgress(100);
      clearInterval(timer);

      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 200);
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
      clearInterval(timer);
    };
  }, [router]);

  if (!loading) return null;

  return (
    <>
      <div
        className="fixed top-0 left-0 right-0 h-1 bg-transparent"
        style={{ zIndex: 9999 }}
      >
        <div
          className="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-200 ease-out shadow-lg"
          style={{
            width: `${progress}%`,
            boxShadow: '0 0 10px rgba(59, 130, 246, 0.5)'
          }}
        />
      </div>
    </>
  );
};

export default LoadingOverlay;
